/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import PropTypes from 'prop-types';
import LocalLogo from '../assets/images/Zerlak_logo_HD.png';

import Button from '../elements/Button';

export default function BrandIcon({ variant }) {
  const textColor = variant === 'light' ? 'text-white' : 'text-theme-blue';
  return (
    <Button className type="link" href="/" aria-label="Zerlak home">
  <div className="flex items-end">
        <img
          src={LocalLogo}
          alt="Z Logo"
          className="h-16 sm:h-20 md:h-24 lg:h-24 w-auto object-contain shrink-0"
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = 'https://zerlak.com/images/logo.png'; }}
        />
        <span className={`${textColor} -ml-4 mb-2.5 sm:-ml-6 md:-ml-8 lg:-ml-10 whitespace-nowrap font-extrabold tracking-wider text-3xl sm:text-4xl md:text-5xl leading-none`}>
          {/* ERLAK */}
        </span>
      </div>
    </Button>
  );
}

BrandIcon.propTypes = {
  variant: PropTypes.oneOf(['dark', 'light']),
};

BrandIcon.defaultProps = {
  variant: 'dark',
};
